import { FormControl } from '@mui/material';
import { Fragment, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useStoreSelector } from 'v3/data/store';
import { DialogMultiDataSelect } from 'v3/shared/components/DialogMultiDataSelect';
import { StyledArrowDropDownIcon } from 'v3/shared/components/Inputs/DropdownSelectFormController/styles';
import { TextFieldStyled } from 'v3/shared/components/Inputs/MultiSelectFormController/styles';
import { ErrorMessage } from 'v3/shared/components/Inputs/styles/defaultStyles';
import { MultiSelectFormControllerProps } from './types';

export const MultiSelectFormController: React.FC<MultiSelectFormControllerProps> = ({
  formControl,
  formControlName,
  label,
}) => {
  const { storeList } = useStoreSelector((store) => store.seller);

  const [open, setOpen] = useState<boolean>(false);

  return (
    <Fragment>
      <DialogMultiDataSelect setOpen={setOpen} open={open} title={label} setOpenModal={setOpen} />

      <Controller
        name={formControlName}
        control={formControl}
        render={({ field: { name }, fieldState: { error } }) => {
          return (
            <FormControl fullWidth>
              <TextFieldStyled
                inputProps={{ 'data-testid': `select-form-controller-${name}` }}
                fullWidth
                label={label}
                name={name}
                autoComplete="off"
                placeholder={'Selecione'}
                onClick={() => setOpen(true)}
                onKeyDown={() => setOpen(true)}
                value={
                  storeList.every((item) => item.checked) && storeList.length > 0
                    ? 'Todas as lojas selecionadas'
                    : storeList.some((item) => item.checked)
                      ? 'Uma ou mais lojas selecionadas'
                      : 'Nenhuma loja selecionada'
                }
                InputProps={{
                  readOnly: true,
                  endAdornment: <StyledArrowDropDownIcon />,
                }}
              />
              <ErrorMessage>{error?.message}</ErrorMessage>
            </FormControl>
          );
        }}
      />
    </Fragment>
  );
};
